import { getEnvBaseUrl } from '@/utils'
import { envConfig } from '@/utils/env'
import { platform } from '@/utils/platform'
import { stringifyQuery } from '@/utils/queryString'

export type CustomRequestOptions = UniApp.RequestOptions & {
  query?: Record<string, any>
  /** 出错时是否隐藏错误提示 */
  hideErrorToast?: boolean
} & IUniUploadFileOptions // 添加uni.uploadFile参数类型

// 请求基准地址
const baseUrl = getEnvBaseUrl().baseUrl

// 拦截器配置
const httpInterceptor = {
  // 拦截前触发
  invoke(options: CustomRequestOptions) {
    // 接口请求支持通过 query 参数配置 queryString
    if (options.query) {
      const queryStr = stringifyQuery(options.query)
      if (options.url.includes('?')) {
        options.url += `&${queryStr}`
      }
      else {
        options.url += `?${queryStr}`
      }
    }
    // 非 http 开头需拼接地址
    if (!options.url.startsWith('http')) {
      // #ifdef H5
      const isProxyRequest = envConfig.useH5Proxy
        && (
          options.url.startsWith(import.meta.env.VITE_APP_PROXY_TIME_PREFIX)
          || options.url.startsWith(import.meta.env.VITE_APP_PROXY_STATIC_PREFIX)
          || options.url.startsWith(import.meta.env.VITE_APP_PROXY_PREFIX)
          || options.url.startsWith(import.meta.env.VITE_APP_PROXY_AUTH_PREFIX)
        )
      if (!isProxyRequest) {
        if (envConfig.useH5Proxy) {
          // 自动拼接代理前缀
          options.url = import.meta.env.VITE_APP_PROXY_PREFIX + options.url
        }
        else {
          options.url = baseUrl + options.url
        }
      }
      // #endif
      // 非H5正常拼接
      // #ifndef H5
      options.url = baseUrl + options.url
      // #endif
      // TIPS: 如果需要对接多个后端服务，也可以在这里处理，拼接成所需要的地址
    }
    // 1. 请求超时
    options.timeout = options.timeout ?? 10000 // 10s
    const isPublicServiceRequest
      = options.url.startsWith(envConfig.timeServerBaseUrl)
        || options.url.startsWith(envConfig.staticServerBaseUrl)
        || (
          envConfig.useH5Proxy
          && (
            options.url.startsWith(import.meta.env.VITE_APP_PROXY_TIME_PREFIX)
            || options.url.startsWith(import.meta.env.VITE_APP_PROXY_STATIC_PREFIX)
          )
        )

    // 公共时间与静态资源服务不需要平台标识，避免 H5 简单 GET 触发额外预检。
    options.header = {
      ...(!isPublicServiceRequest && { platform }),
      ...options.header,
    }
  },
}

export const requestInterceptor = {
  install() {
    // 拦截 request 请求
    uni.addInterceptor('request', httpInterceptor)
    // 拦截 uploadFile 文件上传
    uni.addInterceptor('uploadFile', httpInterceptor)
  },
}
